export const {
  REACT_APP_MAIN_RESET_PASSWORD = '/',
  REACT_APP_MAIN_FAQ = 'https://support.hmbradley.com',
  REACT_APP_MAIN_DASHBOARD = 'http://localhost:3000',
} = process.env;
